export default __webpack_public_path__ + "static/media/top-image.c6d83208.png";